export enum ImageOriginEnum {
  Mention = 'mention',
  MediaLibrary = 'mediaLibrary',
  Url = 'url'
}

export const allImageOrigins = [ ImageOriginEnum.Mention, ImageOriginEnum.MediaLibrary, ImageOriginEnum.Url ];
